<div>
    <app-page-breadcrumb pageTitle="Gestión de Perfiles" />

    <div class="grid grid-cols-1 xl:grid-cols-5 gap-5">

        <!-- ═══════ PANEL IZQUIERDO: lista de perfiles ═══════ -->
        <div class="xl:col-span-2 rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">

            <div class="flex items-center justify-between px-5 pt-5 pb-3">
                <h2 class="text-base font-semibold text-gray-800 dark:text-white">Perfiles</h2>
                <button type="button" (click)="openCreate()"
                    class="inline-flex items-center gap-1.5 rounded-lg bg-brand-500 px-3 py-1.5 text-xs font-medium text-white hover:bg-brand-600 transition-colors">
                    <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
                    </svg>
                    Nuevo
                </button>
            </div>

            <!-- Buscador -->
            <div class="px-5 pb-3">
                <input type="text" placeholder="Buscar perfil..."
                    [(ngModel)]="searchTerm"
                    class="w-full h-9 px-3 text-sm rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-white/5 dark:text-white placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-500" />
            </div>

            @if (loading) {
            <p class="px-5 pb-5 text-sm text-gray-400">Cargando...</p>
            } @else if (filteredProfiles.length === 0) {
            <p class="px-5 pb-5 text-sm text-gray-400">Sin resultados.</p>
            } @else {
            <ul class="divide-y divide-gray-100 dark:divide-gray-800">
                @for (profile of filteredProfiles; track profile.id) {
                <li
                    (click)="selectProfile(profile)"
                    class="flex items-center justify-between px-5 py-3 cursor-pointer transition-colors hover:bg-gray-50 dark:hover:bg-white/5"
                    [class.bg-brand-50]="selectedProfile?.id === profile.id"
                    [class.dark:bg-brand-900/20]="selectedProfile?.id === profile.id">

                    <div class="flex items-center gap-3">
                        <div class="w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold text-white"
                            [class.bg-brand-500]="profile.status === 1"
                            [class.bg-gray-400]="profile.status !== 1">
                            {{ profile.name.charAt(0).toUpperCase() }}
                        </div>
                        <div>
                            <p class="text-sm font-medium text-gray-800 dark:text-white">{{ profile.name }}</p>
                            <app-badge size="sm" [color]="profile.status === 1 ? 'success' : 'error'" class="mt-0.5">
                                {{ profile.status === 1 ? 'Activo' : 'Inactivo' }}
                            </app-badge>
                        </div>
                    </div>

                    <div class="flex items-center gap-1.5" (click)="$event.stopPropagation()">
                        <button type="button" (click)="openEdit(profile)"
                            class="p-1.5 rounded-lg text-gray-400 hover:bg-gray-100 dark:hover:bg-white/10 transition-colors">
                            <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                        </button>
                        <button type="button" (click)="toggleStatus(profile)"
                            class="p-1.5 rounded-lg transition-colors"
                            [class]="profile.status === 1 ? 'text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20' : 'text-green-500 hover:bg-green-50 dark:hover:bg-green-900/20'">
                            <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    [attr.d]="profile.status === 1 ? 'M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 115.636 5.636m12.728 12.728L5.636 5.636' : 'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'" />
                            </svg>
                        </button>
                    </div>
                </li>
                }
            </ul>
            }
        </div>

        <!-- ═══════ PANEL DERECHO: árbol de permisos ═══════ -->
        <div class="xl:col-span-3 rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">

            @if (!selectedProfile) {
            <div class="flex flex-col items-center justify-center h-full min-h-80 gap-3 text-gray-400">
                <svg class="w-16 h-16 opacity-30" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="1.5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
                <p class="text-sm font-medium">Selecciona un perfil para gestionar sus permisos</p>
            </div>
            } @else {

            <!-- Header del panel de permisos -->
            <div class="flex items-center justify-between px-5 pt-5 pb-4 border-b border-gray-100 dark:border-gray-800">
                <div>
                    <h3 class="text-base font-semibold text-gray-800 dark:text-white">
                        Permisos — {{ selectedProfile.name }}
                    </h3>
                    <p class="text-xs text-gray-400 mt-0.5">
                        {{ permissionsCount }} acceso(s) seleccionado(s)
                    </p>
                </div>
                <button type="button" (click)="savePermissions()" [disabled]="savingPermissions || loadingPermissions"
                    class="inline-flex items-center gap-2 rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white hover:bg-brand-600 disabled:opacity-50 transition-colors">
                    @if (savingPermissions) {
                    <svg class="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
                    </svg>
                    Guardando…
                    } @else {
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                    </svg>
                    Guardar permisos
                    }
                </button>
            </div>

            @if (loadingPermissions) {
            <div class="flex items-center justify-center py-16">
                <svg class="w-8 h-8 animate-spin text-brand-500" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
                </svg>
            </div>
            } @else {

            <!-- Árbol de permisos -->
            <div class="p-5 space-y-3 overflow-y-auto max-h-[65vh]">
                @for (node of menuTree; track node.parent.id) {

                @if (node.isStandalone) {
                <!-- Ítem standalone (NAVBAR sin hijos) -->
                <div class="rounded-xl border overflow-hidden transition-colors select-none"
                    [class.border-brand-200]="node.allChecked"
                    [class.dark:border-brand-800]="node.allChecked"
                    [class.border-gray-200]="!node.allChecked"
                    [class.dark:border-gray-700]="!node.allChecked"
                    [class.cursor-pointer]="node.parent.status === 1"
                    [class.cursor-not-allowed]="node.parent.status !== 1"
                    [class.opacity-50]="node.parent.status !== 1"
                    (click)="node.parent.status === 1 && toggleParent(node)">
                    <div class="flex items-center gap-3 px-4 py-3 bg-white dark:bg-gray-900"
                        [class.bg-brand-50]="node.allChecked"
                        [class.dark:bg-brand-900/20]="node.allChecked">
                        <div class="w-5 h-5 rounded border-2 flex items-center justify-center shrink-0 transition-colors"
                            [class.bg-brand-500]="node.allChecked"
                            [class.border-brand-500]="node.allChecked"
                            [class.border-gray-300]="!node.allChecked"
                            [class.dark:border-gray-600]="!node.allChecked">
                            @if (node.allChecked) {
                            <svg class="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="3">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                            </svg>
                            }
                        </div>
                        <div>
                            <div class="flex items-center gap-2">
                                <p class="text-sm font-semibold text-gray-800 dark:text-white">{{ node.parent.name }}</p>
                                @if (node.parent.status !== 1) {
                                <span class="inline-flex items-center rounded-full bg-red-100 dark:bg-red-900/30 px-1.5 py-0.5 text-[10px] font-medium text-red-600 dark:text-red-400">Inactivo</span>
                                }
                            </div>
                            <p class="text-xs text-gray-400 font-mono">{{ node.parent.path }}</p>
                        </div>
                    </div>
                </div>
                } @else {
                <!-- Grupo con hijos -->
                <div class="rounded-xl border overflow-hidden transition-colors"
                    [class.border-brand-200]="node.someChecked"
                    [class.dark:border-brand-800]="node.someChecked"
                    [class.border-gray-200]="!node.someChecked"
                    [class.dark:border-gray-700]="!node.someChecked">

                    <!-- Cabecera del grupo -->
                    <div class="flex items-center gap-3 px-4 py-3 cursor-pointer select-none bg-white dark:bg-gray-900"
                        [class.bg-brand-50]="node.someChecked"
                        [class.dark:bg-brand-900/20]="node.someChecked">

                        <!-- Checkbox padre -->
                        <div class="relative flex items-center" (click)="toggleParent(node)">
                            <div class="w-5 h-5 rounded border-2 flex items-center justify-center transition-colors cursor-pointer"
                                [class.bg-brand-500]="node.allChecked"
                                [class.border-brand-500]="node.allChecked || node.someChecked"
                                [class.border-gray-300]="!node.allChecked && !node.someChecked"
                                [class.dark:border-gray-600]="!node.allChecked && !node.someChecked">
                                @if (node.allChecked) {
                                <svg class="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="3">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                                </svg>
                                } @else if (node.someChecked) {
                                <div class="w-2.5 h-0.5 bg-brand-500 rounded"></div>
                                }
                            </div>
                        </div>

                        <div class="flex-1 flex items-center justify-between" (click)="toggleNodeExpand(node)">
                            <span class="text-sm font-semibold text-gray-800 dark:text-white">{{ node.parent.name }}</span>
                            <div class="flex items-center gap-2">
                                <span class="text-xs text-gray-400">
                                    {{ checkedCount(node) }}/{{ node.children.length }}
                                </span>
                                <svg class="w-4 h-4 text-gray-400 transition-transform duration-200"
                                    [class.-rotate-90]="!node.expanded"
                                    fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                                </svg>
                            </div>
                        </div>
                    </div>

                    <!-- Hijos -->
                    @if (node.expanded) {
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-px bg-gray-100 dark:bg-gray-800 border-t border-gray-100 dark:border-gray-800">
                        @for (child of node.children; track child.id) {
                        <div class="flex items-center gap-3 px-4 py-2.5 bg-white dark:bg-gray-900 transition-colors select-none"
                            [class]="child.status === 1 ? 'cursor-pointer hover:bg-gray-50 dark:hover:bg-white/3' : 'cursor-not-allowed opacity-50'"
                            (click)="child.status === 1 && toggleChild(node, child)">
                            <div class="w-4 h-4 rounded border-2 flex items-center justify-center shrink-0 transition-colors"
                                [class.bg-brand-500]="child.checked"
                                [class.border-brand-500]="child.checked"
                                [class.border-gray-300]="!child.checked"
                                [class.dark:border-gray-600]="!child.checked">
                                @if (child.checked) {
                                <svg class="w-2.5 h-2.5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="3">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                                </svg>
                                }
                            </div>
                            <div>
                                <div class="flex items-center gap-2">
                                    <p class="text-sm text-gray-700 dark:text-gray-300">{{ child.name }}</p>
                                    @if (child.status !== 1) {
                                    <span class="inline-flex items-center rounded-full bg-red-100 dark:bg-red-900/30 px-1.5 py-0.5 text-[10px] font-medium text-red-600 dark:text-red-400">Inactivo</span>
                                    }
                                </div>
                                @if (child.path) {
                                <p class="text-xs text-gray-400 font-mono">{{ child.path }}</p>
                                }
                            </div>
                        </div>
                        }
                    </div>
                    }
                </div>
                }

                }

                @if (menuTree.length === 0) {
                <p class="text-center text-sm text-gray-400 py-8">No hay menús configurados en el sistema.</p>
                }
            </div>

            }
            }
        </div>
    </div>

    <!-- MODAL crear/editar perfil -->
    @if (showModal) {
    <div class="fixed inset-0 z-99999 flex items-center justify-center bg-black/50 p-4" (click)="closeModal()">
        <div class="w-full max-w-sm rounded-2xl bg-white dark:bg-gray-900 p-6 shadow-xl" (click)="$event.stopPropagation()">
            <h3 class="text-lg font-semibold text-gray-800 dark:text-white mb-5">
                {{ isEditing ? 'Editar perfil' : 'Nuevo perfil' }}
            </h3>
            <div class="space-y-4">
                <div>
                    <label class="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Nombre *</label>
                    <input type="text" [(ngModel)]="formName" placeholder="Ej: Administrador"
                        class="w-full px-3 py-2 text-sm rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-white/5 dark:text-white focus:outline-none focus:ring-2 focus:ring-brand-500"
                        [class.border-red-400]="formSubmitted && !formName.trim()" />
                    @if (formSubmitted && !formName.trim()) {
                    <p class="mt-1 text-xs text-red-500">El nombre es obligatorio</p>
                    }
                </div>
                <div>
                    <label class="block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1">Estado</label>
                    <select [(ngModel)]="formStatus"
                        class="w-full px-3 py-2 text-sm rounded-lg border border-gray-300 dark:border-gray-700 bg-white dark:bg-white/5 dark:text-white focus:outline-none focus:ring-2 focus:ring-brand-500">
                        <option [value]="1">Activo</option>
                        <option [value]="0">Inactivo</option>
                    </select>
                </div>
            </div>
            <div class="flex justify-end gap-3 mt-6">
                <button type="button" (click)="closeModal()"
                    class="px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 dark:border-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-white/5">
                    Cancelar
                </button>
                <button type="button" (click)="saveProfile()" [disabled]="submitting"
                    class="px-4 py-2 text-sm font-medium rounded-lg bg-brand-500 text-white hover:bg-brand-600 disabled:opacity-50">
                    {{ submitting ? 'Guardando...' : 'Guardar' }}
                </button>
            </div>
        </div>
    </div>
    }
</div>
